import {Link} from "react-router";
import {Building2, CreditCard, Gauge, KeyRound, PackageSearch, UsersRound, type LucideIcon} from "lucide-react";

type Group = {title: string; icon: LucideIcon; actions: Array<{label: string; to: string; destructive?: boolean}>};

const groups: Group[] = [
  {title: "Users", icon: UsersRound, actions: [
    {label: "Create user", to: "/users/create"},
    {label: "Update user", to: "/users?mode=update"},
    {label: "Delete user", to: "/users?mode=delete", destructive: true},
  ]},
  {title: "Organizations", icon: Building2, actions: [
    {label: "Create organization", to: "/organizations/create"},
    {label: "Update organization", to: "/organizations/update"},
    {label: "Delete organization", to: "/organizations/delete", destructive: true},
    {label: "Manage organizations", to: "/organizations"},
    {label: "Add member", to: "/organizations/add-member"},
  ]},
  {title: "Products", icon: PackageSearch, actions: [
    {label: "Create product", to: "/products/create"},
    {label: "Update product", to: "/products/update"},
    {label: "Delete product", to: "/products/delete", destructive: true},
    {label: "Deactivate product", to: "/products/deactivate"},
  ]},
  {title: "API credentials", icon: KeyRound, actions: [
    {label: "Create API credential", to: "/api-keys/create"},
    {label: "Update API credential", to: "/api-keys/update"},
    {label: "Delete API credential", to: "/api-keys/delete", destructive: true},
    {label: "Review API keys", to: "/api-keys/review"},
    {label: "Deactivate API key", to: "/api-keys/deactivate"},
  ]},
  {title: "Subscriptions", icon: CreditCard, actions: [
    {label: "Create subscription", to: "/subscriptions/create"},
    {label: "Update subscription", to: "/subscriptions/update"},
    {label: "Delete subscription", to: "/subscriptions/delete", destructive: true},
    {label: "Cancel subscription", to: "/subscriptions/cancel"},
  ]},
  {title: "Rate limits", icon: Gauge, actions: [
    {label: "Product limits", to: "/rate-limits/products"},
    {label: "Subscription limits", to: "/rate-limits/subscriptions"},
  ]},
];

export function AdminDashboard() {
  return <div className="admin-page admin-operations">
    <header className="admin-operations__header"><span>ADMIN / CRUD</span><h1>Administration</h1><p>Select one operation.</p></header>
    <div className="admin-entity-grid">
      {groups.map((group) => { const Icon = group.icon; return <article className="admin-entity-card" key={group.title}>
        <div className="admin-entity-card__heading"><span className="admin-entity-card__icon"><Icon aria-hidden="true" /></span><div><h2>{group.title}</h2></div></div>
        <div className="admin-entity-card__actions">
          {group.actions.map((action) => <Link key={action.to} to={action.to} className={action.destructive ? "is-destructive" : undefined}>{action.label}</Link>)}
        </div>
      </article>;})}
    </div>
  </div>;
}
